<template>
  <div>
    <!-- Mobile search form -->
    <div
      id="mobileSearchButton"
      class="mobile-search-button"
      @click="showSearchForm"
    >
      <div class="mobile-search-icon">
        <i class="fa fa-search mobile-hotel-search-icon" />
      </div>
      <div class="mobile-search-info">
        <span class="mobile-info-search-location">{{ destination }}</span>
        <div class="mobile-dates-room-info">
          <span class="mobile-hotel-dates">
            {{ getDates() }}
          </span>
          <span class="mobile-hotel-rooms">
            {{ roomQuantity }}
            {{ roomQuantity > 1 ? $t('h4h.rooms') : $t('h4h.room') }}
          </span>
        </div>
      </div>
    </div>
    <!-- Desktop search form -->
    <form
      class="hotel-search-form"
      @submit.prevent="submitForm"
    >
      <!-- Destination search box -->
      <div class="destination">
        <label for="hotel_search_destination">
          {{ $t('h4h.destination') }}
          <i
            class="fa fa-times"
            @click="exitSearchForm"
          />
        </label>
        <i class="fa fa-map-marker" />
        <input
          id="hotel_search_destination"
          v-model="destination"
          v-validate="'required'"
          class="form-control"
          type="text"
          :placeholder="$t(&quot;h4h.destinationPlaceholder&quot;)"
          name="destination"
        >
        <label
          v-show="errors.has('destination')"
          class="hotel_form_search_error"
          for="hotel_search_destination"
        >{{ errors.first('destination') }}</label>
      </div>
      <!-- check in and out box -->
      <div class="stay-dates">
        <label for="hotel_search_datepicker">
          {{ $t('h4h.checkIn') }} - {{ $t('h4h.checkOut') }}
        </label>
        <date-picker
          id="hotel_search_datepicker"
          v-model="selectedDates"
          class="date-field"
          :disabled-date="notBeforeToday"
          :editable="false"
          type="date"
          range
          :popup-style="pickerPosition"
          placeholder="Select date range"
          @focus="displayEventDots"
          @calendar-change="hideEventDots"
          @open="changePosition"
        />
      </div>
      <!-- Room quantity and update search button -->
      <div class="mobile-hotel-date-holder">
        <div class="room-quantity-parent">
          <div class="room-quantity">
            <label>
              {{ $t('h4h.roomNum') }}
            </label>
            <div class="counter">
              <span
                :class="[disableSubtraction ? 'disable' : '', 'subtract']"
                @click="updateRoomQuantity(-1, 'subtract')"
              />
              <span class="number-of-rooms">
                {{ roomQuantity }}
              </span>
              <span
                :class="[disableAddition ? 'disable' : '', 'add']"
                @click="updateRoomQuantity(1, 'add')"
              />
            </div>
          </div>
        </div>
        <button
          class="btn btn-secondary update-search"
          type="submit"
        >
          {{ $t('h4h.updateSearch') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
/* global google locale */
import DatePicker from 'vue2-datepicker'
import mixin from './hotel_availability'
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    DatePicker
  },

  mixins: [mixin],

  data() {
    return {
      destination: null,
      latitude: null,
      longitude: null,
      selectedDates: [],
      eventDates: [],
      roomQuantity: 1,
      pickerPosition: { left: 0 }
    }
  },

  computed: {
    ...mapState({
      hotel: state => state.hotel
    }),
    ...mapGetters('hotel', ['sendCheckInToArn', 'sendCheckOutToArn', 'getCheckInDate', 'getCheckOutDate']),
    disableSubtraction() {
      return this.roomQuantity < 2
    },
    disableAddition() {
      return this.roomQuantity >= this.$store.state.packages.packageQty
    }
  },

  async mounted() {
    // Setup destination
    this.destination = this.hotel.destination
    this.latitude = this.hotel.searchLatitude
    this.longitude = this.hotel.searchLongitude
    this.enableAutocomplete()

    // Setup date picker
    await this.calendarLocale()
    this.selectedDates.push(this.hotel.checkInDate, this.hotel.checkOutDate)
    let el = document.getElementsByClassName('mx-input')
    el[0].setAttribute('readonly', true)

    // Setup room quantity
    this.roomQuantity = this.hotel.roomQty
  },

  methods: {
    ...mapMutations('hotel', [
      'setRetailLoading',
      'updateDestination',
      'updateSearchLat',
      'updateSearchLng',
      'updateCheckInDate',
      'updateCheckOutDate',
      'updateRoomQty',
      'increaseRoomQty'
    ]),
    showSearchForm() {
      document.body.classList.toggle('mobile-search-form')
      let searchButton = document.getElementById('mobileSearchButton')
      searchButton.style.display='none'
    },
    getDates(){
      let dateFormat = { month:'short', day:'numeric' }
      let checkin = new Date(this.$store.state.hotel.checkInDate)
      let checkout = new Date(this.$store.state.hotel.checkOutDate)
      let checkInDate = checkin.toLocaleString( window.locale , dateFormat)
      let checkOutDate = checkout.toLocaleString( window.locale , dateFormat)
      return `${checkInDate} - ${checkOutDate}`
    },
    exitSearchForm() {
      document.body.classList.toggle('mobile-search-form')
      let searchButton = document.getElementById('mobileSearchButton')
      searchButton.style.display = 'flex'
    },
    enableAutocomplete() {
      let input = document.getElementById('hotel_search_destination')
      let autocomplete = new google.maps.places.Autocomplete(input)

      autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])


      google.maps.event.addDomListener(input, 'keydown', event => {
        let dropdown = document.getElementsByClassName('pac-container')[0]
        if (event.keyCode === 13 && dropdown.style.display !== 'none') {
          event.preventDefault()
        }
      })

      const component = this
      autocomplete.addListener('place_changed', () => {

        let place = autocomplete.getPlace()
        component.destination = input.value
        component.latitude = place.geometry.location.lat()
        component.longitude = place.geometry.location.lng()
      })
    },
    notBeforeToday(date) {
      return date < new Date(Date.now() - 86400000)
    },
    displayEventDots() {
      let calElement = document
        .getElementsByClassName('mx-calendar mx-calendar-panel-date')[1]
      calElement.style.display = 'none'

      if (this.eventDates.length < 1) {
        let date = this.hotel.contractedCheckInDate
        while(date <= this.hotel.contractedCheckOutDate) {
          this.eventDates.push(this.formatDate(date))
          date.setDate(date.getDate() + 1)
        }
      }

      this.eventDates.forEach(date => {
        window.setTimeout(() => {}, 100)
        let el = document.querySelector('[title="'+ date +'"]')
        let eventDot = document.createElement('div')
        eventDot.setAttribute('class', 'event-dot')
        el.insertBefore(eventDot, el.firstElementChild.previousSibling)
      })
    },
    hideEventDots() {
      this.eventDates.forEach(date => {
        let el = null
        this.$nextTick(() => {
          el = document.querySelector('[title="'+ date +'"]')
          let dots = document.getElementsByClassName('event-dot')
          if (el && (el.className !== 'cell not-current-month')) {
            dots.forEach(dot => {
              dot.style.display = 'block'
            })
          } else {
            dots.forEach(dot => {
              dot.style.display = 'none'
            })
          }
        })
      })
    },
    changePosition() {
      this.pickerPosition = {
        left: `${document.
          getElementById('hotel_search_datepicker').
          getBoundingClientRect().left}px`
      }
    },
    async calendarLocale() {
      switch (locale) {
      case 'es-MX':
        await import('vue2-datepicker/locale/es')
        break
      case 'de':
        await import('vue2-datepicker/locale/de')
        break
      case 'it':
        await import('vue2-datepicker/locale/it')
        break
      case 'fr':
        await import('vue2-datepicker/locale/fr')
        break
      case 'ja':
        await import('vue2-datepicker/locale/ja')
        break
      case 'zh-CN':
        await import('vue2-datepicker/locale/zh-cn')
        break
      case 'pl':
        await import('vue2-datepicker/locale/pl')
        break
      default:
        break
      }
    },
    formatDate(date) {
      let year = date.getFullYear()
      let month = '' + (date.getMonth() + 1)
      let day = '' + date.getDate()

      if (month.length < 2)
        month = '0' + month
      if (day.length < 2)
        day = '0' + day

      return [year, month, day].join('-')
    },
    updateRoomQuantity(value, operation) {
      switch(operation) {
      case 'add':
        if (!this.disableAddition) {
          this.roomQuantity += 1
        }
        break

      case 'subtract':
        if (!this.disableSubtraction) {
          this.roomQuantity -= 1
        }
        break
      }
    },
    async submitForm() {
      this.setRetailLoading(true)
      this.updateDestination(this.destination)
      this.updateCheckInDate(this.selectedDates[0])
      this.updateCheckOutDate(this.selectedDates[1])
      this.updateRoomQty(this.roomQuantity)
      await this.fetchGeocode()
    },
    async fetchGeocode() {
      if (this.latitude && this.longitude) {
        this.updateSearchLat(this.latitude)
        this.updateSearchLng(this.longitude)
        this.fetchAvailableHotels(
          this.latitude,
          this.longitude,
          this.reformatCheckIn(),
          this.reformatCheckOut(),
          this.roomQuantity
        )
        this.latitude = null
        this.longitude = null
      } else {
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ address: this.destination }, (results, status) => {
          if (status === 'OK') {
            this.latitude = results[0].geometry.location.lat()
            this.longitude = results[0].geometry.location.lng()
            this.updateSearchLat(this.latitude)
            this.updateSearchLng(this.longitude)
            this.fetchAvailableHotels(
              this.latitude,
              this.longitude,
              this.reformatCheckIn(),
              this.reformatCheckOut(),
              this.roomQuantity
            )
            this.latitude = null
            this.longitude = null
          } else {
            this.setRetailLoading(false)
          }
        })
      }
    },
    reformatCheckIn(){
      let day = this.$store.state.hotel.checkInDate.getDate()
      let month = this.$store.state.hotel.checkInDate.getMonth() + 1
      let year = this.$store.state.hotel.checkInDate .getFullYear()

      return [year, month, day].join('-')
    },
    reformatCheckOut(){
      let day = this.$store.state.hotel.checkOutDate.getDate()
      let month = this.$store.state.hotel.checkOutDate.getMonth() + 1
      let year = this.$store.state.hotel.checkOutDate .getFullYear()

      return [year, month, day].join('-')
    }
  }
}
</script>
